import { HandBack, ecId, upper, type JanusCtx, type Row } from '../ability/context.js';
import { boundaryVerdict, resolveGmBoundary, type GmBoundaryVerdict } from './gm-boundary.js';
import { statusItemId } from './expiry.js';
import { readPlayerCharacterField } from '../display/player-character-field.js';
import { readCreatureStatuses } from '../compile/creature-status-reader.js';

export const HUNGER_THIRST_TICK = '88F8F0BA-3E96-4D9C-AFCE-008D849B0BFC';

/** Toggle maintenance uses the same duration, immunity, gain/loss and connection resolvers as ordinary statuses. */
export function planCampaignNeedsToggle(ctx: JanusCtx, actorId: string, enabled: boolean): GmBoundaryVerdict & { catalog: Record<string, Row> } {
    // Removal's mutating readers need resolved carriers too. Native lean rows may store only status_arr: UUID.
    for (const row of [ctx.encounter, ...ctx.members.values()]) row.statuses = {
        target: Object.values(readCreatureStatuses(row, 'target', ctx.read.definition)),
        caster: Object.values(readCreatureStatuses(row, 'caster', ctx.read.definition)),
    };
    const actor = ctx.members.get(upper(actorId));
    if (!actor) throw new HandBack('campaign-needs:actor-not-held');
    if (enabled) {
        if (!Number(readPlayerCharacterField(actor, 'player_character_inactive') ?? 0)) {
            ctx.statusConnectedId = ctx.read.uuid();
            resolveGmBoundary(ctx, { kind: 'add', targetId: ecId(actor), casterId: ecId(actor), itemId: HUNGER_THIRST_TICK,
                originId: '', durationInt: '1', durationType: 'hours', logMessage: false, allowNoChange: true });
        }
    } else {
        // The legacy single-connection remover visits every matching target row, including inactive PCs.
        for (const status of [...ctx.read.statuses(actor)]) if (statusItemId(status) === HUNGER_THIRST_TICK) {
            resolveGmBoundary(ctx, { kind: 'delete', targetId: ecId(actor), statusId: upper(status.status_id), scope: 'single', logMessage: false });
        }
    }
    const verdict = boundaryVerdict(ctx), catalog: Record<string, Row> = {};
    for (const status of [...verdict.statusesAdded, ...verdict.statusStacks]) {
        status.status_id ??= ctx.read.uuid();
        const def = ctx.read.definition(status.status_item_id);
        if (def) catalog[status.status_item_id] = def;
    }
    return { ...verdict, catalog };
}
